module.exports = __webpack_public_path__ + "img/icon_benefit-quality-of-life.e7c6205c.svg";